import nextAction from 'model/actions/utilities/nextAction';

const end = onDone => ({
  title: 'Long Tom',
  description: [
    'this must be one of the villains. the rest must have left this Tom scoundrel behind to die of his consumption',
    'but which boy? is it the one I see in my nightmares? could he be my boy?',
    'I remount my horse and hurry on my way. maybe I can still save someone.'
  ],
  buttons: [nextAction('Continue', onDone)]
});

const search = onDone => ({
  title: 'Long Tom',
  description: [
    "searching the dead man's belongings, I find a letter to his wife. his last",
    'tattered and torn, I still make out some of the writing:',
    '',
    '"...the priest said it\'s okay... we taking the boy to... had to kill every... The ransom money will pay for our... a doctor for this cough...  tried to interfere so we... direct your letters as before.',
    '',
    'Yours, Tom"'
  ],
  buttons: [nextAction('What boy?', () => onDone(end(onDone)))]
});

const approach = onDone => ({
  title: 'Long Tom',
  description: [
    'a man. half propped against a rock. lanky. head tilted back.',
    'I approach with a greeting: no response. I reach my hand to touch him but withdraw quickly.',
    "there's a foul smell in the air. rotting flesh. I back away ready to leave, when something catches my eye.",
    'a map.',
    "the same one I've been following"
  ],
  buttons: [nextAction('Search', () => onDone(search(onDone)))]
});

const start = onDone => ({
  title: 'Long Tom',
  description: [
    "it's been many days of riding alone. no sign of people for miles",
    "suddenly - a plume of smoke on the horizon. coming from the direction I'm headed",
    'a dying fire by the side of the road. down to coals.',
    'I approach cautiously'
  ],
  buttons: [nextAction('Approach', () => onDone(approach(onDone)))]
});

export default start;
